export const formatCurrency = (amount) => {
  if (amount === undefined || amount === null) return '$0';
  
  if (amount >= 1000000000000) {
    return `$${(amount / 1000000000000).toFixed(1)}T`;
  } else if (amount >= 1000000000) {
    return `$${(amount / 1000000000).toFixed(1)}B`;
  } else if (amount >= 1000000) {
    return `$${(amount / 1000000).toFixed(1)}M`;
  }
  
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: amount < 1000 ? 2 : 0,
    maximumFractionDigits: amount < 1000 ? 2 : 0
  }).format(amount);
}; 